module.exports = __webpack_public_path__ + "assets/eaf92e0d8b95df08f82cbc4d7bf774f0.mp3";